

	$(function () {
  searchWord = function () {
    var searchResult,
      searchText = $(this).val(), // 検索ボックスに入力された値
      targetText,
      hitNum;
    // 検索結果を格納するための配列を用意
    searchResult = [];
    // 検索結果エリアの表示を空にする
    $('#search-result__list').empty();
    $('.search-result__hit-num').empty();
    // 検索ボックスに値が入ってる場合
    if (searchText != '') {
      $('.target-area li').each(function () {
        targetText = $(this).html();
        // 検索対象となるリストに入力された文字列が存在するかどうかを判断
        if (targetText.indexOf(searchText) != -1) {
          // 存在する場合はそのリストのテキストを用意した配列に格納
          searchResult.push(targetText);
        }
      });
      // 検索結果をページに出力
      for (var i = 0; i < searchResult.length; i++) {
        $('#search-result__list').append('<li>' + searchResult[i] + '</li>');
      }
      // ヒットの件数をページに出力
      window.CP.exitedLoop(0);
      hitNum = '<span>検索結果</span>：' + searchResult.length + '件見つかりました。';
      $('.search-result__hit-num').append(hitNum);
    }
  };
  // searchWordの実行
  $('#search-text').on('input', searchWord);
});
